<template>
  <v-container fluid pa-0 ma-0 transition="slide-x-transition">
    <v-card flat>
      <v-card-text>
        <v-container fluid pa-0 ma-0>
          <v-layout row wrap>
            <v-flex xs12 text-xs-center pb-4>
              <div v-if="transaction.account_receipt_header_1">{{ transaction.account_receipt_header_1 }}</div>
              <div v-if="transaction.account_receipt_header_2">{{ transaction.account_receipt_header_2 }}</div>
              <div v-if="transaction.account_receipt_header_3">{{ transaction.account_receipt_header_3 }}</div>
            </v-flex>

            <v-flex xs4>
              <span v-if="transaction.merchant_id">Merchant ID: {{ transaction.merchant_id }}</span><br />
              Terminal ID: {{ transaction.terminal_code }}<br />
              Date: {{ date(transaction.settled ? transaction.settled : (transaction.authorized ? transaction.authorized : transaction.created)) }}<br />
              Time: {{ time(transaction.settled ? transaction.settled : (transaction.authorized ? transaction.authorized : transaction.created)) }}<br />
              <div v-if="transaction.request_type === 'authorize' || transaction.request_type === 'sale'">Auth No: {{ transaction.auth_code }}</div>

              <h3>{{ transaction.payment_type ? transaction.payment_type.toUpperCase() : '' }}</h3>
              ************{{ transaction.last_four }}<br />
              <br />

              <template v-if="transaction.request_type === 'sale' || transaction.request_type === 'ach'">
                <div>SALE AMOUNT ${{ ((transaction.total_amount - transaction.fee_amount - transaction.tax_amount) / 100).toFixed(2) }}</div>
                <div v-if="transaction.is_cashdiscount || transaction.fee_amount">PRICE ADJ FEE ${{ (transaction.fee_amount / 100).toFixed(2) }}</div>
                <div v-if="transaction.tax_amount">TAX ${{ (transaction.tax_amount / 100).toFixed(2) }}</div>

                <div>TOTAL ${{ (transaction.total_amount / 100).toFixed(2) }}</div>
                <div v-if="credited">REFUNDED ${{ (credited / 100).toFixed(2) }}</div>
              </template>

              <template v-else-if="transaction.request_type === 'credit' || transaction.request_type === 'achcredit'">
                <div>REFUND AMOUNT (${{ (transaction.total_amount / 100).toFixed(2) }})</div>
              </template>

              <template v-else>
                <div>VOID AMOUNT (${{ (transaction.parent_total_amount / 100).toFixed(2) }})</div>
              </template>

            </v-flex>

            <v-flex xs4>
              <div class="primary--text">Customer Details</div>
              <div v-if="transaction.billing_name"><h3>{{ transaction.billing_name }}</h3></div>
              <div v-if="transaction.billing_address"> {{ transaction.billing_address }}</div>
              <div v-if="transaction.billing_city || transaction.billing_state || transaction.billing_postal_code">
                {{ transaction.billing_city }}
                {{ transaction.billing_state }}
                {{ transaction.billing_postal_code }}
              </div>
              <div v-if="transaction.billing_country && transaction.billing_country !== 'USA'"> {{ transaction.billing_country }}</div>

              <v-spacer></v-spacer>
              <div v-if="transaction.customer_po">Customer PO: {{ transaction.customer_po }}</div>
              <div v-if="transaction.custom_field_1">{{ transaction.custom_field_1 }}</div>
              <div v-if="transaction.custom_field_2">{{ transaction.custom_field_2 }}</div>
              <div v-if="transaction.custom_field_3">{{ transaction.custom_field_3 }}</div>

            </v-flex>

            <v-flex xs4>
              <template v-if="transaction.account_logo">
                <v-img contain max-height="100px" max-width="200px" position="left, center" :src="imageUrl + '/' + transaction.account_logo"/>
              </template>
              <h3>{{ transaction.account_name }}</h3>
              <div v-if="transaction.account_street_1"> {{ transaction.account_street_1 }}</div>
              <div v-if="transaction.account_street_2"> {{ transaction.account_street_2 }}</div>
              <div v-if="transaction.account_city || transaction.account_state || transaction.account_zip">
                {{ transaction.account_city }}
                {{ transaction.account_state }}
                {{ transaction.account_zip }}
              </div>
              <div v-if="transaction.account_phone"> {{ phone(transaction.account_phone) }}</div>
              <div v-if="transaction.account_email && !accountPermissions.hide_email_on_receipt"> {{ transaction.account_email }}</div>
            </v-flex>

            <v-flex xs12 text-xs-center pt-4>
              <div v-if="transaction.account_receipt_footer_1">{{ transaction.account_receipt_footer_1 }}</div>
              <div v-if="transaction.account_receipt_footer_2">{{ transaction.account_receipt_footer_2 }}</div>
              <div v-if="transaction.account_receipt_footer_3">{{ transaction.account_receipt_footer_3 }}</div>
            </v-flex>
          </v-layout>

          <v-divider/>

          <v-divider class="primary" />

          <v-layout row wrap>
            <div class="primary--text">Please keep this receipt for your records</div>
            <v-spacer/>
            <v-btn color="primary" @click="print">Print</v-btn>
            <v-btn @click="email" v-if="transaction.billing_email">Email</v-btn>
          </v-layout>
        </v-container>
      </v-card-text>
    </v-card>

    <ReceiptPrint ref="receipt" :transaction="transaction"></ReceiptPrint>
  </v-container>
</template>

<script>
import Bus from '@/bus'

import ApiMixin from '@/mixins/api'
import AuthMixin from '@/mixins/auth'
import DisplayMixin from '@/mixins/display'
import StoreMixin from '@/store/mixin'

import ReceiptPrint from './ReceiptPrint.vue'

export default {
  mixins: [ApiMixin, AuthMixin, DisplayMixin, StoreMixin],
  components: {ReceiptPrint},

  data: function () {
    return {
      enabled: false,
      imageUrl: process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-dev-images.s3.us-west-2.amazonaws.com'
    }
  },

  props: {
    transaction: Object
  },

  mounted () {
    if (process.env.NODE_ENV === 'production') {
      this.imageUrl = process.env.VUE_APP_IMAGE_URL || 'https://paynetworx-images.s3.us-west-2.amazonaws.com'
    }
  },

  computed: {
    accountPermissions: function () {
      let accountPermissions = {}

      if (this.transaction && this.transaction.hasOwnProperty('account_permissions') && this.transaction.account_permissions) {
        if (typeof this.transaction.account_permissions === 'object') {
          accountPermissions = this.transaction.account_permissions
        } else {
          try {
            accountPermissions = JSON.parse(this.transaction.account_permissions)
          } catch (error) {
            accountPermissions = {}
          }
        }
      }

      return accountPermissions
    },
    credited: function () {
      if (!this.transaction.hasOwnProperty('associatedTransactions') || this.transaction.associatedTransactions.length < 1) {
        return 0
      }

      let totalCredited = this.transaction.associatedTransactions.reduce((runningTotal, transaction) => {
        if (transaction.request_type === 'credit' && transaction.response_code === '000') {
          return runningTotal + transaction.total_amount
        }
      }, 0)
      if (!totalCredited) totalCredited = 0
      return totalCredited
    }
  },

  methods: {
    print () {
      this.$refs.receipt.print()
    },

    async email () {
      try {
        if (!this.transaction || !this.transaction.id) {
          throw new Error('Unable to identify transaction')
        }

        let result = await this.api({
          method: 'get',
          url: `/transactions/${this.transaction.id}/send_receipt_email`
        })

        console.log('sent email')
        console.log(result)

        if (result.data && result.data.error === false) {
          Bus.$emit('openModal', {status: 'success', message: 'Email sent'})
        } else {
          Bus.$emit('openModal', {status: 'error', message: 'Unexpected Error'})
        }
      } catch (err) {
        Bus.$emit('openModal', {status: 'error', message: err})
      }
    },
    save () {}
  }
}
</script>



// WEBPACK FOOTER //
// src/components/transactions/Receipt.vue